import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { loginAction } from "../../Actions/UserActions.js";
const Page = styled.div`
margin: auto;
width: 50%;
border: 3px solid green;
padding: 10px;
border-radius: 5px;
text-align: center;
font-size:25px;
`;


const Label = styled.label`
    padding:20px;
    
`;


export class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = { data: {}, serverErrors: {} };

        this.handleSubmit = this.handleSubmit.bind(this);
        console.info('Login - constructor called.');
    }

    componentWillMount() {
        console.info('Login - componentWillMount called.');
    }

    componentDidMount() {
        console.info('Login - componentDidMount called.');
    }

    componentWillReceiveProps(nextProps) {

    }

    shouldComponentUpdate() {
        return true;
    }

    componentWillUpdate() {
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
    }


    onChange(e) {

    }


    render() {
        console.info('Login - render called.');
        return (
            <Page>
            <h1>LOGIN</h1>
            <form onSubmit={this.handleSubmit}>
                    <Label>
                        mail:
                        <input type="text" ref={(email) => this.email = email} />
                    </Label>
                   <br/>
                   <br/>
                    <Label>
                        pass:
                        <input type="password" ref={(pwd) => this.pwd = pwd} />
                    </Label>
                    <br/>
                    <input type="submit" value="Submit"  />
                </form>
 
            </Page>
        );
    }

    handleSubmit(e){
       
        e.preventDefault();
        this.props.loginAction(this.email.value, this.pwd.value);
        
       
        
    }
}

/**
 * Get data from store
 * @param state
 */
const mapStateToProps = state => ({
    mystate: state
});

/**
 * Import action from dir action above - but must be passed to connect method in order to trigger reducer in store
 * @type {{UserUpdate: UserUpdateAction}}
 */
const mapActionsToProps = {
    loginAction
};

export default connect(mapStateToProps, mapActionsToProps)(Login);



// WEBPACK FOOTER //
// ./src/Components/Login/Login.js